import React from 'react'

export const IconEmail = (props) => {
  return (
    <svg viewBox="0 0 23 23" fill="none" stroke='currentColor' xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 1L8.7 6.5L16.4 1M1 12H16.4V1H1V12Z" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
